module.exports = __webpack_public_path__ + "img/product-active.6f3f99ec.svg";